<template>
  <div class="item">
    <template v-if="types.boolField === metadata.type">
      <editable-bool
        :label="metadata.label"
        :name="metadata.name"
        :initial-value="metadata.initialValue"
        :validator="metadata.validator"
        :saver="metadata.saver"
        :readonly="metadata.readonly"
        v-bind="fieldProps"
      ></editable-bool>
    </template>
    <template v-else-if="types.section === metadata.type">
      <h4>{{ metadata.label }}</h4>
      <profile-item
        v-for="field in metadata.fields"
        :metadata="field"
        :key="field.name"
        :field-props="field.fieldProps"
        :readonly="field.readonly"
      ></profile-item>
    </template>
    <template v-else-if="types.select === metadata.type">
      <editable-select
        :label="metadata.label"
        :name="metadata.name"
        :initial-value="metadata.initialValue"
        :validator="metadata.validator"
        :saver="metadata.saver"
        :readonly="metadata.readonly"
        v-bind="fieldProps"
      ></editable-select>
    </template>
    <template v-else-if="types.textArea === metadata.type">
      <editable-text-area
        :label="metadata.label"
        :name="metadata.name"
        :initial-value="metadata.initialValue"
        :validator="metadata.validator"
        :saver="metadata.saver"
        :readonly="metadata.readonly"
        v-bind="fieldProps"
      ></editable-text-area>
    </template>
    <template v-else-if="types.textField === metadata.type">
      <editable-text
        :label="metadata.label"
        :name="metadata.name"
        :initial-value="metadata.initialValue"
        :validator="metadata.validator"
        :saver="metadata.saver"
        :readonly="metadata.readonly"
        v-bind="fieldProps"
      ></editable-text>
    </template>
    <template v-else-if="types.userLinker === metadata.type">
      <user-linker
        :relationship="metadata.relationship"
        v-bind="metadata.fieldProps"
      ></user-linker>
    </template>
    <template v-else-if="types.userList === metadata.type">
      <template v-for="user in metadata.initialValue">
        <linked-user
          :key="user.id"
          :user="user"
          :relationship="metadata.relationship"
          :readonly="metadata.readonly"
        ></linked-user>
      </template>
    </template>
    <template v-else-if="types.user === metadata.type">
      <linked-user
        :user="metadata.initialValue"
        :relationship="metadata.relationship"
        :readonly="metadata.readonly"
      ></linked-user>
    </template>
    <p v-else>Unknown field type: {{ metadata.type }}</p>
    <template v-if="metadata.afterHtml">
      <div v-html="metadata.afterHtml"></div>
    </template>
  </div>
</template>

<script>
import EditableBool from "../forms/EditableBool";
import EditableText from "../forms/EditableText";
import EditableTextArea from "../forms/EditableTextArea";
import EditableSelect from "../forms/EditableSelect";
import LinkedUser from "./LinkedUser";
import UserLinker from "./UserLinker";

export const BoolFieldType = "EditableBool";
export const SectionType = "Section";
export const SelectType = "EditableSelect";
export const TextFieldType = "EditableText";
export const TextAreaType = "EditableTextArea";
export const UserLinkerType = "UserLinker";
export const UserListType = "UserList";
export const UserType = "User";

export const Types = {
  boolField: BoolFieldType,
  section: SectionType,
  select: SelectType,
  textArea: TextAreaType,
  textField: TextFieldType,
  user: UserType,
  userLinker: UserLinkerType,
  userList: UserListType
};
export default {
  name: "ProfileItem",
  components: {
    EditableBool,
    EditableSelect,
    EditableText,
    EditableTextArea,
    LinkedUser,
    UserLinker
  },
  data() {
    return {
      types: Types
    };
  },
  props: {
    metadata: Object,
    fieldProps: { type: Object, default: () => {} }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
